export const scrollToElem = elementId => {
  const elm = document.getElementById(elementId);
  if (elm) {
    elm.scrollIntoView({ behavior: 'smooth' });
  }
};



// WEBPACK FOOTER //
// ./src/utilities/scrollToElem.js